import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const scannerCreateAtom = createMutationAtomFactory(
  'settings.scannerCreate',
  (params: {
    sidecarId: string;
    uniqueId: string;
    driverType: string;
    name: string;
  }) => ({
    iotScannerCreate: {
      __args: {
        input: {
          sidecarId: params.sidecarId,
          uniqueId: params.uniqueId,
          driverType: params.driverType,
          name: params.name,
        },
      },
      id: true,
      name: true,
      status: true,
      driverType: true,
    },
  }),
);
